import { render, staticRenderFns } from "./EditCustomDocEmployerSignature.vue?vue&type=template&id=1a04db9b&scoped=true&"
import script from "./EditCustomDocEmployerSignature.vue?vue&type=script&lang=js&"
export * from "./EditCustomDocEmployerSignature.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomDocEmployerSignature.vue?vue&type=style&index=0&id=1a04db9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a04db9b",
  null
  
)

export default component.exports